/**
 * ═══════════════════════════════════════════════════════════════
 * SAT Generator 3.0 — DesmosViewer (Phase 6 / PR-D4-020 / PR-D4-033)
 *
 * PR-D4-020: Полная замена внешнего Desmos CDN на Native Vector Renderer.
 *   - Устранены внешние вызовы к desmos.com/api (403 Forbidden).
 *   - Приоритет 1: Рендерит векторные SVG-диаграммы геометрии.
 *   - Приоритет 2: Рендерит нативный векторный декартов график функций
 *     и точек через SvgCartesianPlane / NativeGraphRenderer.
 *
 * Architectural SSOT: docs/Global_Graphic_Standards.md (GGS)
 * Display contract:   fixed viewBox 0 0 500 500, width=100%,
 *                     preserveAspectRatio=xMidYMid meet, ≥30px inset
 *                     (docs/agent-configs/ggs-invariant.md / PR-D4-033).
 * ═══════════════════════════════════════════════════════════════
 */

import type { GraphData } from '../lib/types';
import { NativeGraphRenderer } from './NativeGraphRenderer';

export interface DesmosViewerProps {
    graphData?: GraphData | null;
    /** Server-generated SVG string for vector geometry fallback */
    svgFallback?: string | null;
    className?: string;
    height?: number | string;
    width?: number | string;
}

export function DesmosViewer({
    graphData = null,
    svgFallback = null,
    className = '',
    height = 320,
    width = '100%',
}: DesmosViewerProps) {
    // If neither graphData nor svgFallback is provided, do not render an empty container
    if (!graphData && !svgFallback) {
        return null;
    }

    return (
        <NativeGraphRenderer
            graphData={graphData}
            svgFallback={svgFallback}
            className={className}
            height={height}
            width={width}
        />
    );
}

export default DesmosViewer;
